import React, { lazy, Suspense } from 'react'
import { BrowserRouter as Router, Route, useHistory, Switch } from 'react-router-dom'
import { SecureRoute, Security, LoginCallback } from '@okta/okta-react'
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js'
import Spinner from 'react-bootstrap/Spinner'
import Container from 'react-bootstrap/Container'

import withErrorBoundary from './hocs/withErrorBoundary'
import App from './App'

const oktaAuth = new OktaAuth({
  issuer: 'https://inform.okta.com/oauth2/default',
  clientId: '0oayqi5lbtRCYKInK0x7',
  redirectUri: window.location.origin + '/login/callback',
})

const Status = lazy(() => import('./containers/Status'))
const Elastic = lazy(() => import('./containers/Elastic'))
const Reindex = lazy(() => import('./containers/Reindex'))
const SeleneReindex = lazy(() => import('./containers/SeleneReindex'))
const Visualization = lazy(() => import('./containers/Visualization'))
const Queue = lazy(() => import('./containers/Queue'))
const Exclusions = lazy(() => import('./containers/Exclusions'))
const AutoVersioning = lazy(() => import('./containers/AutoVersioning'))
const NotFound = lazy(() => import('./containers/NotFound'))

function LoadingRoute() {
  return (
    <Container fluid className="d-flex flex-column flex-fill align-items-center justify-content-center">
      <Spinner animation="border" variant="primary" />
    </Container>
  )
}

function Routes() {
  const history = useHistory()
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.replace(toRelativeUrl(originalUri || '/', window.location.origin))
  }

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <App>
        <Suspense fallback={<LoadingRoute />}>
          <Switch>
            <SecureRoute exact path="/">
              <Status />
            </SecureRoute>

            <SecureRoute exact path="/elastic">
              <Elastic />
            </SecureRoute>

            <SecureRoute exact path="/reindex">
              <Reindex />
            </SecureRoute>

            <SecureRoute exact path="/selene-reindex">
              <SeleneReindex />
            </SecureRoute>

            <SecureRoute exact path="/elasticVisualization">
              <Visualization />
            </SecureRoute>

            <SecureRoute exact path="/queueManagement">
              <Queue />
            </SecureRoute>

            <SecureRoute exact path="/exclusions">
              <Exclusions />
            </SecureRoute>

            <SecureRoute exact path="/autoVersioning">
              <AutoVersioning />
            </SecureRoute>

            <Route path="/login/callback">
              <LoginCallback />
            </Route>

            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </Suspense>
      </App>
    </Security>
  )
}

const AppWithRouterAccess = () => (
  <Router>
    <Routes />
  </Router>
)
export default withErrorBoundary(AppWithRouterAccess)
